import { Deserializable } from '../../../lib';
import { OptionListItemDto } from '../../../lib/models/dto/option-list-item-dto';

export class DeclarationPageContentDto implements Deserializable {
  public Labels: Array<string>;
  public Flags: Array<string>;
  public IdentityVerification: Array<OptionListItemDto>;

  deserialize(input: any): this {
    Object.assign(this, input);
    this.IdentityVerification = input.IdentityVerification.map((optionListItemDto: OptionListItemDto) =>
      new OptionListItemDto().deserialize(optionListItemDto)
    );

    return this;
  }
}
